import { render, staticRenderFns } from "./integralExchange.vue?vue&type=template&id=ba673730&scoped=true"
import script from "./integralExchange.vue?vue&type=script&lang=js"
export * from "./integralExchange.vue?vue&type=script&lang=js"
import style0 from "./integralExchange.vue?vue&type=style&index=0&id=ba673730&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba673730",
  null
  
)

export default component.exports